import { MapPin } from "lucide-react";
import Container from "@/components/ui/Container";

const PROMOTIONS = [
  {
    title: "7 Days Plan in Berlin",
    location: "Berlin, Germany",
    image: "https://images.unsplash.com/photo-1560969184-10fe8719e047?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    large: false,
  },
  {
    title: "5 Days Plan for Maldives",
    location: "Maldives",
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    large: false,
  },
  {
    title: "5 Days Plan for Kyoto, Japan",
    location: "Kyoto, Japan",
    image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    large: false,
  },
  {
    title: "10 Days Plan for Maui, Hawaii",
    location: "Maui, Hawaii",
    image: "https://images.unsplash.com/photo-1542259009477-d625272157b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    large: false,
  },
];

export function PromotionsJustForYou() {
  return (
    <section className="py-16 bg-[#FDF9F5]">
      <Container>
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <h3 className="text-[#0F766E] font-medium text-lg">Exclusive Plans</h3>
            <h2 className="text-[#0F766E] text-3xl font-bold mt-1">Promotions Just For You</h2>
          </div>
          
          <div className="flex gap-6 text-sm font-medium">
            <button className="text-[#ED6F2E]">All</button>
            <button className="text-gray-500 hover:text-gray-900 transition-colors">Popular</button>
            <button className="text-gray-500 hover:text-gray-900 transition-colors">Recent</button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          {PROMOTIONS.map((plan, idx) => (
            <div 
              key={idx} 
              className="relative overflow-hidden rounded-[20px] group cursor-pointer h-[260px] shadow-sm hover:shadow-md transition-shadow"
            >
              <img 
                src={plan.image} 
                alt={plan.title} 
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              
              <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                <h3 className="text-xl font-semibold mb-2">{plan.title}</h3>
                <div className="flex items-center text-sm text-gray-200">
                  <MapPin size={16} className="mr-1" />
                  {plan.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
